export const transportationTypes = ["passenger", "cargo"] as const;

export type TransportationType = (typeof transportationTypes)[number];
